if(typeof __WEBPACK_EXTERNAL_MODULE_esprima__ === 'undefined') {var e = new Error("Cannot find module \"esprima\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = __WEBPACK_EXTERNAL_MODULE_esprima__;


//////////////////
// WEBPACK FOOTER
// external "esprima"
// module id = esprima
// module chunks = 0